import styled from 'styled-components';

export default styled.div`
  position: absolute;
  width: 240px;
  top: 25px;
  left: calc(50% - 120px);

  .wrapper {
    display: flex;
    flex-direction: column;

    img {
      height: 25px;
      position: relative;
      bottom: -2px;
    }
  }

  .content {
    background-color: ${(props) => props.theme.colors.grey};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.24);
  }
`;
